"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _Util = require("../../Util");

var _ = require("../../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Modal = function Modal(props) {
  var parent = props.parent;
  var className = props.className;
  var fillScreen = props.fillScreen;
  var open = props.open;
  var onShadeClick = props.onShadeClick;
  var children = props.children;
  var attr = Object.assign({}, props, {
    className: null,
    open: null,
    onShadeClick: null,
    children: null,
    fillScreen: null
  });

  var _useState = (0, _react.useState)(open),
      _useState2 = _slicedToArray(_useState, 2),
      wasOpen = _useState2[0],
      setWasOpen = _useState2[1];

  var onKeyUp = function onKeyUp(e) {
    switch (e.keyCode) {
      case 27:
        // escape
        onShadeClick();
        break;

      default:
        break;
    }
  };

  (0, _react.useEffect)(function () {
    document.removeEventListener("keyup", onKeyUp);
    document.addEventListener("keyup", onKeyUp);
    return function () {
      document.removeEventListener("keyup", onKeyUp);
      console.log("hard eject removing lock from body");
      (0, _Util.removeClassName)(document.body, "locked");
    };
  }, []);
  (0, _react.useEffect)(function () {
    var query = ".Modal";

    if (className) {
      query += "." + className;
    }

    query += " > *";
    var element = document.querySelector(query);
    console.log("modal open context element", element);

    if (element) {
      if (open) {
        (0, _.trackEvent)({
          action: "Modal Opened",
          element: element
        });
      }
    }
  }, [open]);
  var cname = "Modal";

  if (className) {
    cname += " " + className;
  }

  if (open) {
    cname += " open";

    if (wasOpen !== open) {
      setWasOpen(open);
    }
  } else {
    if (wasOpen) {
      cname += " closed";
      setTimeout(function () {
        setWasOpen(false);
        (0, _Util.removeClassName)(document.body, "locked");
      }, 600);
    }
  }

  if (open || wasOpen) {
    (0, _Util.addClassName)(document.body, "locked");
  }

  attr.trkContext = null;
  var modalWindowInnerClassName = fillScreen ? "ModalWindowInner" : "ModalWindowInner partial-screen-fill";

  if (parent) {
    return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.Element, {
      trkContext: props.trkContext,
      className: cname
    }, /*#__PURE__*/_react.default.createElement(_.Shade, {
      onClick: onShadeClick
    }), /*#__PURE__*/_react.default.createElement(_.Element, _extends({}, attr, {
      className: modalWindowInnerClassName,
      background: _.Color.White
    }), children))), parent);
  } else {
    return /*#__PURE__*/_react.default.createElement(_.Element, {
      trkContext: props.trkContext,
      className: cname
    }, /*#__PURE__*/_react.default.createElement(_.Shade, {
      onClick: onShadeClick
    }), /*#__PURE__*/_react.default.createElement(_.Element, _extends({}, attr, {
      className: modalWindowInnerClassName,
      background: _.Color.White
    }), children));
  }
};

exports.Modal = Modal;
Modal.defaultProps = {
  fillScreen: true
};